import React from "react";
import { Container } from "@mui/material";
import OffreTemplate from "../components/OffreTemplate";
import SEO from "../components/SEO";
import GuideLeadForm from "../components/GuideLeadForm";
import SeoInternalLinks from "../components/SeoInternalLinks";
import exampleSite1 from "../assets/images/projets/lecozenWebSite.png";
import exampleSite2 from "../assets/images/projets/amelieWebSite.png";
import exampleSite3 from "../assets/images/projets/semaphoresWebSite.png";
import exampleSite4 from "../assets/images/projets/nicolasWebSite.png";
import exampleSite5 from "../assets/images/projets/morganCoiffure.png";
//import exampleSite5 from "../assets/images/projets/lemanoiretoileWebSite.png";
import imgWeb1 from "../assets/images/web1.png";
import imgWeb2 from "../assets/images/web2.png";
import imgWeb3 from "../assets/images/web3.png";
import imgWeb4 from "../assets/images/web4.png";

export default function OffreWebPage() {
  return (
    <>
      <SEO
        title="Création de site web sur mesure | Développeur web freelance | DigiBuddy"
        description="Création de site internet sur mesure pour indépendants et PME : vitrine, refonte et pages orientées conversion. Socle SEO et évolutions."
        keywords="création site web sur mesure, développeur web freelance, refonte site web, site vitrine professionnel, création site internet PME, maintenance site web, SEO site vitrine"
        url="https://www.digibuddy.fr/creation-site-web-sur-mesure"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Création de Sites Web sur Mesure",
          description:
            "Sites web qui convertissent vos prospects en clients. Design moderne, SEO optimisé, responsive.",
          provider: {
            "@type": "Organization",
            name: "DigiBuddy",
          },
          areaServed: "FR",
          serviceType: "Développement web",
          offers: {
            "@type": "Offer",
            price: "À partir de 2000€",
            priceCurrency: "EUR",
          },
        }}
      />
      <OffreTemplate
        title="Sites web qui convertissent"
        intro="<b>Transformez votre présence en ligne en machine à convertir.<br>Design moderne, résultats mesurables.</b><br><br>Votre site devient votre meilleur commercial, disponible 24h/24 et 7j/7."
        bannerImage="/images/banner-web.jpg"
        url="https://www.digibuddy.fr/creation-site-web-sur-mesure"
        sections={[
          {
            title: "Sites qui génèrent des leads",
            subtitle: "Vos visiteurs deviennent vos clients",
            paragraph:
              "Nous créons des sites web qui ne se contentent pas d'être beaux, mais qui convertissent réellement vos visiteurs en clients. Chaque élément est pensé pour déclencher l'action.",
            bullets: [
              "Landing pages optimisées conversion",
              "Sites e-commerce qui vendent",
              "Sites vitrine qui génèrent des contacts",
              "Refonte de sites existants pour booster les résultats",
            ],
            imageSrc: imgWeb1,
          },
          {
            title: "Design moderne et professionnel",
            subtitle: "Une image qui inspire confiance",
            paragraph:
              "Première impression = décision d'achat. Nous créons des designs modernes qui reflètent votre professionnalisme et inspirent confiance dès le premier coup d'œil.",
            bullets: [
              "Design responsive (PC, tablette, mobile)",
              "Identité visuelle cohérente avec votre marque",
              "Navigation intuitive et appels à l'action visibles",
              "Expérience utilisateur optimisée",
            ],
            imageSrc: imgWeb2,
          },
          {
            title: "Référencement naturel optimisé",
            subtitle: "Trouvez vos clients avant vos concurrents",
            paragraph:
              "Un beau site qui ne se trouve pas n'est pas utile. Nous optimisons votre référencement pour que vos prospects vous trouvent facilement sur Google.",
            bullets: [
              "Optimisation SEO pour être visible sur Google",
              "Contenus optimisés pour vos mots-clés",
              "Structure technique pour les moteurs de recherche",
              "Suivi des performances et améliorations continues",
            ],
            imageSrc: imgWeb3,
          },
          {
            title: "Accompagnement complet",
            subtitle: "De la conception à la mise en ligne",
            paragraph:
              "Nous vous accompagnons à chaque étape : audit de votre présence actuelle, conception, développement, mise en ligne et suivi des performances.",
            bullets: [
              "Audit gratuit de votre présence en ligne",
              "Hébergement sécurisé et nom de domaine inclus",
              "Formation à la gestion de votre site",
              "Maintenance et améliorations continues",
            ],
            imageSrc: imgWeb4,
          },
        ]}
        galleryImages={[
          exampleSite1,
          exampleSite2,
          exampleSite3,
          exampleSite4,
          exampleSite5,
        ]}
      />
      <Container sx={{ py: 2 }} style={{ maxWidth: "800px" }}>
        <SeoInternalLinks
          title="Guides utiles"
          links={[
            {
              to: "/combien-coute-site-web-sur-mesure",
              label: "Combien coûte un site web sur mesure en 2026 ?",
            },
            {
              to: "/freelance-ou-agence-pour-creer-son-site",
              label: "Freelance ou agence pour créer son site ?",
            },
            { to: "/", label: "Accueil" },
          ]}
        />
        <GuideLeadForm source="seo-page" />
      </Container>
    </>
  );
}
